import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08f8c36a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=08f8c36a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f8c36a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f8c36a')) {
      api.createRecord('08f8c36a', component.options)
    } else {
      api.reload('08f8c36a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=08f8c36a&scoped=true", function () {
      api.rerender('08f8c36a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/work-order/index.vue"
export default component.exports